module.exports = __webpack_public_path__ + "img/six_forty.0273f805.svg";